module.exports = __webpack_public_path__ + "static/media/Telenet_Belgio.c7015f2c.png";